define([
    "dojo/_base/declare",
    "csi/action/Controller",
    "./PriceListActionMixin"
], function(declare,ReviseController,PriceListActionMixin) {

    return declare([ReviseController, PriceListActionMixin], {
        
        m_operation: "RevisePriceList"
 
    });
});